import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import WorshipLocationDetailsItem from './componests/WorshipLocationDetailsItem';

const WorshipLocationDetails = ({
  currentWorshipLocation,
  getWorshipLocationByid,
  resetWorshipLocationsByid,
  addAlertToAlerts,
  currentUser,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = params;
  const mapView = searchParams.get('mapview') || false;

  useEffect(() => {
    getWorshipLocationByid(id);

    return () => {
      resetWorshipLocationsByid();
    };
  }, []);

  return (
    <div className="worship-details-container">
      <GridContainer>
        <div className="worship-details-container--upper">
          <div
            className="worship-details-container-header-back-link"
            onClick={() => navigate(`/worship-locations/?mapview=${mapView}`)}
          >
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Worship Locations</h3>
        </div>
        {currentWorshipLocation ? (
          <WorshipLocationDetailsItem
            worship={currentWorshipLocation}
            addAlertToAlerts={addAlertToAlerts}
            currentUser={currentUser}

          />
        ) : (
          <div className="d-flex pt-4">
            <p className="worship-details-container-text">
              We are unable to find the worship location. Please try again later.
            </p>
          </div>
        )}
      </GridContainer>
    </div>
  );
};

export default WorshipLocationDetails;
